import * as React from 'react';
import Header from '@component/Header'
import Bottom from '@component/Bottom'
import AlertMessage from '@component/AlertMessage'
import { gameList, OpenApiDoMain } from '@src/constants'
import './style.scss'
import axios from 'axios'
// import Item from '../Item';

export interface IGameDetailProps {
  location: any,
  match: any
}

export interface IGameDetailState {
  showAlert: boolean,
  itemLink: string
}


export default class GameDetail extends React.Component<IGameDetailProps, IGameDetailState> {
  constructor(props: IGameDetailProps) {
    super(props)
    this.state = {
      showAlert: false,
      itemLink: "http://gg.cn/res/guanwang_sign_align.apk"
    }
  }

  public componentDidMount() {
    this.getLink()
    scrollTo(0, 0)
    const index = this.props.match.params.id
    if (index === '0') {
      document.title = "域起音舞类手游下载、社交音乐类手游、域起精品手游"
      document.getElementsByTagName("meta")[4].content = '域起萌舞OL、梦幻炫舞、音舞手游、二次元手游、初音未来、社交手游'
      document.getElementsByTagName("meta")[5].content = '域起《梦幻炫舞》是由上海域起网络科技有限公司倾力自主研发的集休闲、时尚、交友等娱乐性于一体的多人在线3D界面音乐舞蹈游戏。原名为《萌舞OL》，已于2019年4月18日正式更名为《梦幻炫舞》。“2019最受女性欢迎的十大手游”《梦幻炫舞》拥有中日声优 阵容，原创故事情节，可进行服装配饰，有四种歌曲玩法模式。'
    }
    else if (index === '1') {
      document.title = "域起棋牌手游下载，休闲竞技手游、域起精品手游"
      document.getElementsByTagName("meta")[4].content = '域起哥哥游戏、哥哥棋牌游戏、GG游戏'
      document.getElementsByTagName("meta")[5].content = '域起GG游戏平台 由上海域起网络科技有限公司自主研发的休闲棋牌游戏平台，平台内的游戏包括，哥哥斗地主，哥哥热血捕鱼，哥哥升级，哥哥双扣等十几款，其中有扑克游戏，麻将游戏，捕鱼游戏等几类。'
    }
  }


  public download(url: string) {
    if (url === '') {
      this.setState({ showAlert: true });
      setTimeout(() => {
        this.setState({ showAlert: false });
      }, 2000);
    } else {
      if (url === 'http://gg.cn/res/guanwang_sign_align.apk') {
        url = this.state.itemLink
        window.open(url)
      } else {
        window.open(url)
      }
    }
  }
  public getLink() {
    const that = this
    axios.get(OpenApiDoMain + '/link?keywords=gg_com_mw')
      .then(res => {
        that.setState({
          itemLink: res.data.data
        })
      })

  }
  public toDomain(domain: string) {
    if (domain !== '') {
      window.open(domain, '_blank')
    }
  }

  public render() {
    let index = this.props.match.params.id
    index = index > gameList.length ? gameList.length : index

    return (
      <div className="pc-game-detail">
        <Header />
        <div className="first-content-game">
          <div>
            <img onClick={this.toDomain.bind(this, gameList[index].domain)} className="icon-style" src={gameList[index].icon} alt="域起官网" />
            <div>
              <div>
                <div className="game-detail-title">{gameList[index].title}</div>
                <div className="game-detail-describe">{gameList[index].describe}</div>
              </div>
              <div className={`download-icon ${gameList[index].iosLink === '' && gameList[index].androidLink === '' ? 'visibility-hidden' : ''}`}>
                <img onClick={this.download.bind(this, gameList[index].iosLink)} src={require("@static/ios_btn.png")} alt="域起官网" />
                <img onClick={this.download.bind(this, gameList[index].androidLink)} src={require("@static/android_btn.png")} alt="域起官网" />
              </div>
            </div>
          </div>
        </div>
        <div className="content-navigation" dangerouslySetInnerHTML={{ __html: gameList[index].content }} />
        <AlertMessage message="敬请期待" show={this.state.showAlert} />
        <Bottom />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GameDetail/index.tsx